var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1202 3.32002H15.0002V0.14003C14.09 0.0453769 13.1754 -0.00135428 12.2602 2.98641e-05C9.54022 2.98641e-05 7.68023 1.66003 7.68023 4.70002V7.32002H4.61023V10.88H7.68023V20H11.3602V10.88H14.4202L14.8802 7.32002H11.3602V5.05002C11.3602 4.00002 11.6402 3.32002 13.1202 3.32002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.950bff6ef70513299c2672279fd02bd5.svg";
export { ForwardRef as ReactComponent };